export enum DrawSource {
  Default = 'Draw_Default',
  Select = 'Draw_Select',
  Edit = 'Draw_Edit',
  Red = 'Draw_Red',
  ExportExtent = 'Draw_ExportExtent',
  ExportSelect = 'Draw_ExportSelect'
}
